<template>
    <div v-if="showFeedBackPanel" class="feedback-panel">
        <div v-if="showFeedBackPanel && showFeedbackThankYouMessage" class="feedback-panel__feedback-thank-you">
            <div class="feedback-panel__text-thank-you-text-container">
                <p class="feedback-panel__text-thank-you" v-html="getEvaFeedbackThankYouMessage"></p>
            </div>
            <div class="feedback-panel__pointer"></div>
            <img src="@/assets/images/chatbot/feedback/feedback_thankyou_robot.png" />
        </div>
        <div v-else class="feedback-panel__feedback-main">
            <img v-if="feedbackType === 'positive'" class="feedback-panel__feedback-positive" src="@/assets/images/chatbot/feedback/feedbackPanelThumbsup.svg" />
            <img v-if="feedbackType === 'negative'" class="feedback-panel__feedback-negative" src="@/assets/images/chatbot/feedback/feedbackPanelThumbsdown.svg" />
            <p class="feedback-panel__text" v-html="getEvaFeedbackDescription"></p>
            <div class="feedback-panel__input-container">
                <TotemTextarea
                    v-model="feedbackText"
                    class="feedback-panel__textarea"
                    :placeholder="getFeedbackPlaceholder"
                />
                <TotemButton
                    class="feedback-panel__send-button"
                    size="medium"
                    color="primary"
                    @click="sendFeedback"
                    :label="$t('Chatbot.feedback_button_submit')"
                />
                <span
                    class="feedback-panel__cancel-button"
                    @click="cancelFeedBack"
                >
                    {{ $t('Chatbot.feedback_button_cancel') }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'FeedbackPanel',
        data () {
            return {
                feedbackText: '',
                showFeedbackThankYouMessage: false,
            }
        },
        props: {
            feedbackType: {
                type: String
            },
            feedbackMessageId: {
                type: String
            }
        },
        computed: {
            ...mapGetters({
                showFeedBackPanel: 'ChatBot/getShowFeedBackPanel'
            }),
            getFeedbackPlaceholder () {
                return this.feedbackType === 'positive' ? this.$t('Chatbot.feedback_textbox_placeholder_positive') : this.$t('Chatbot.feedback_textbox_placeholder_negative')
            },
            getEvaFeedbackDescription () {
                return this.$t('Chatbot.help_us_make_eva_better')
            },
            getEvaFeedbackThankYouMessage () {
                return this.$t('Chatbot.thank_you_for_feedback')
            }
        },
        methods: {
            async cancelFeedBack () {
                await this.$store.dispatch('ChatBot/showFeedBackPanel', false)
                this.feedbackText = ''
            },
            async sendFeedback () {
                await this.$store.dispatch('ChatBot/sendFeedback', { feedbackText: this.feedbackText, type: this.feedbackType, messageId: this.feedbackMessageId })
                this.showFeedbackThankYouMessage = true
                setTimeout(async () => {
                    await this.$store.dispatch('ChatBot/showFeedBackPanel', false)
                    this.showFeedbackThankYouMessage = false
                    this.$emit('update-feedback-icons')
                }, 2000)
                this.feedbackText = ''
            },
        }

    }
</script>

<style lang="scss" scoped>
    .feedback-panel {
        border: 0;
        width: 540px;
        background-color: $alabaster;
        opacity: 1;
        border-radius: 0px 0px 10px 10px;
        font-family: Quicksand-Regular;
        text-align: center;
        position: absolute;
        z-index: 2000;
        padding: 100px 50px;
        height: calc(100vh - 270px);
        display: flex;
        justify-content: center;
        align-items: center;
        overflow-y: auto;

        [class*="mobile"] & {
            width: 100%;
            height: 100%;
        }

        &__feedback-main {
            max-height: 100%;
        }

        &__pointer {
            height: 40px;
            width: 40px;
            background: $champagne;
            margin: 0 auto;
            transform: rotate(45deg);
            margin-top: -40px;
            position: relative;
            left: calc(0.5vw - 50px);
            z-index: -200;
        }

        &__feedback-thank-you {
            margin: 25% 0;
        }

        &__text-thank-you-text-container {
            background: $champagne;
            padding: 18px 25px;
            margin: 0 auto;
            width: max-content;
            border-radius: 10px;
        }

        &__text-thank-you {
            font-size: 1.7rem;
            white-space: nowrap;
            overflow: hidden;
            margin: 0 auto;
            width: max-content;
        }

        &__text {
            font-size: 2.2rem;
            margin: 20px 0;
        }

        &__input-container {
            margin: 35px 0;
            display: flex;
            flex-direction: column;
        }

        &__textarea {
            width: 100%;
            height: 100px;
            border: 1px solid $gray;
            padding: 10px;
            font-size: 1.6rem;
            font-family: Quicksand-Regular;
            margin: 0 0 30px 0;
            background: $white !important;
        }

        &__cancel-button {
            margin: 40px 0px;
            cursor: pointer;
            text-decoration: underline;
            color: $burnt_orange;
            font-family: 'Nunito-Regular';
        }

        &__send-button {
            width: 200px;
            margin: 0 auto;
        }

        &__feedback-positive {
            background-color: $fringy_flower;
            padding: 15px;
            border-radius: 9px;
        }

        &__feedback-negative {
            background-color: $azalea;
            padding: 15px;
            border-radius: 9px;
        }
    }

</style>

